module.exports = __webpack_public_path__ + "img/slide-4.e6141a33.jpg";